var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-shell"},[_c('EmptyState',{attrs:{"title":"页面不存在","description":"访问的页面不存在或暂未配置，请检查菜单权限与路由地址。","icon":"el-icon-warning-outline"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("返回工作台")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }